export function normalizeText(raw: unknown): string {
  return String(raw ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

export function safeTrim(raw: unknown): string {
  return String(raw ?? "").trim();
}

export function normalizeWordChars(raw: unknown): string {
  return String(raw ?? "")
    .replace(/[^\w]/gi, "")
    .toLowerCase();
}

export function formatCnpj(raw: unknown): string {
  const digits = String(raw ?? "").replace(/\D/g, "");
  if (digits.length !== 14) return String(raw ?? "");

  return digits.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
    "$1.$2.$3/$4-$5",
  );
}

